export enum CatalogueTypes {
    GROUP = 'group',
    TAXONOMY = 'taxonomy'
}
